import { IGap } from '../_contracts/IGap';

export class Gap implements IGap {
    id: number;
    name: string;
    isSelected: boolean;
    count?: number;
    status?: string;
    minValue?: number;
    caseGapId?: number;
    itemsModified?: number;
    isCustomOpportunity: boolean;

    constructor(id?: number, name?: string, isSelected?: boolean, count?: number, status?: string,
        minValue?: number, caseGapId?: number, itemsModified?: number, gap?: IGap, isCustomOpportunity?: boolean) {
        if (gap != null) {
            this.id = gap.id;
            this.name = gap.name;
            this.isSelected = gap.isSelected;
            this.count = gap.count;
            this.status = gap.status;
            this.itemsModified = gap.itemsModified;
            gap.minValue > 0 ? this.minValue = gap.minValue : this.minValue = 1;
            this.caseGapId = gap.caseGapId;
            this.isCustomOpportunity = gap.isCustomOpportunity;
        } else {
            this.id = id;
            this.name = name;
            this.isSelected = isSelected;
            this.count = count;
            this.status = status;
            this.itemsModified = itemsModified;
            minValue > 0 ? this.minValue = minValue : this.minValue = 1;
            this.caseGapId = caseGapId;
            this.isCustomOpportunity = isCustomOpportunity;
        }
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/value-tracker/_models/Gap.ts